//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    authorization_GetAccountAuthorizationDisplayInfo(): Observable<AccountAuthorizationDisplayInfoDto | null> {
        let url_ = this.baseUrl + "/api/v3/Authorization/displayinfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthorization_GetAccountAuthorizationDisplayInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthorization_GetAccountAuthorizationDisplayInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountAuthorizationDisplayInfoDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountAuthorizationDisplayInfoDto | null>;
        }));
    }

    protected processAuthorization_GetAccountAuthorizationDisplayInfo(response: HttpResponseBase): Observable<AccountAuthorizationDisplayInfoDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountAuthorizationDisplayInfoDto;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountAuthorizationDisplayInfoDto;
            return _observableOf(result204);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    authorization_GetEffectiveAccountRoles(): Observable<RolesDto | null> {
        let url_ = this.baseUrl + "/api/v3/Authorization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthorization_GetEffectiveAccountRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthorization_GetEffectiveAccountRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolesDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolesDto | null>;
        }));
    }

    protected processAuthorization_GetEffectiveAccountRoles(response: HttpResponseBase): Observable<RolesDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RolesDto;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RolesDto;
            return _observableOf(result204);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    authorization_GetNeedsAuthentication(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v3/Authorization/needsAuthentication";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthorization_GetNeedsAuthentication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthorization_GetNeedsAuthentication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAuthorization_GetNeedsAuthentication(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    softwarepartnerApiPublic_GetSession(apiSessionId: string): Observable<SoftwarepartnerApiSessionDto | null> {
        let url_ = this.baseUrl + "/api/v3/SoftwarepartnerApiPublic/session/{apiSessionId}";
        if (apiSessionId === undefined || apiSessionId === null)
            throw new Error("The parameter 'apiSessionId' must be defined.");
        url_ = url_.replace("{apiSessionId}", encodeURIComponent("" + apiSessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSoftwarepartnerApiPublic_GetSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSoftwarepartnerApiPublic_GetSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SoftwarepartnerApiSessionDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SoftwarepartnerApiSessionDto | null>;
        }));
    }

    protected processSoftwarepartnerApiPublic_GetSession(response: HttpResponseBase): Observable<SoftwarepartnerApiSessionDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SoftwarepartnerApiSessionDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    userMenu_GetUserMenuDisplayInfos(): Observable<UserMenuDisplayInfoDto | null> {
        let url_ = this.baseUrl + "/api/v3/UserMenu";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserMenu_GetUserMenuDisplayInfos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserMenu_GetUserMenuDisplayInfos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserMenuDisplayInfoDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserMenuDisplayInfoDto | null>;
        }));
    }

    protected processUserMenu_GetUserMenuDisplayInfos(response: HttpResponseBase): Observable<UserMenuDisplayInfoDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserMenuDisplayInfoDto;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserMenuDisplayInfoDto;
            return _observableOf(result204);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    userMenu_GetUserMenuDisplayInfosByCatalogKey(catalogKey: string): Observable<UserMenuDisplayInfoDto | null> {
        let url_ = this.baseUrl + "/api/v3/UserMenu/catalogKey/{catalogKey}";
        if (catalogKey === undefined || catalogKey === null)
            throw new Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserMenu_GetUserMenuDisplayInfosByCatalogKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserMenu_GetUserMenuDisplayInfosByCatalogKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserMenuDisplayInfoDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserMenuDisplayInfoDto | null>;
        }));
    }

    protected processUserMenu_GetUserMenuDisplayInfosByCatalogKey(response: HttpResponseBase): Observable<UserMenuDisplayInfoDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserMenuDisplayInfoDto;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserMenuDisplayInfoDto;
            return _observableOf(result204);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    userMenu_GetUserLanguage(): Observable<AccountLanguage> {
        let url_ = this.baseUrl + "/api/v3/UserMenu/language";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserMenu_GetUserLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserMenu_GetUserLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountLanguage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountLanguage>;
        }));
    }

    protected processUserMenu_GetUserLanguage(response: HttpResponseBase): Observable<AccountLanguage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountLanguage;
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountLanguage;
            return _observableOf(result204);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    softwareIntegrationApi_GetSession(sessionId: string): Observable<SoftwareIntegrationApiSessionDto | null> {
        let url_ = this.baseUrl + "/api/v3/SoftwareIntegrationApi/session/sessionId/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSoftwareIntegrationApi_GetSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSoftwareIntegrationApi_GetSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SoftwareIntegrationApiSessionDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SoftwareIntegrationApiSessionDto | null>;
        }));
    }

    protected processSoftwareIntegrationApi_GetSession(response: HttpResponseBase): Observable<SoftwareIntegrationApiSessionDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SoftwareIntegrationApiSessionDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    softwareIntegrationApi_UpdateSessionUiSelectionData(sessionId: string, dto?: SoftwareIntegrationApiUiSelectionDataDto | null | undefined): Observable<SoftwareIntegrationApiSessionDto | null> {
        let url_ = this.baseUrl + "/api/v3/SoftwareIntegrationApi/updateSessionUiSelectionData/sessionId/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSoftwareIntegrationApi_UpdateSessionUiSelectionData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSoftwareIntegrationApi_UpdateSessionUiSelectionData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SoftwareIntegrationApiSessionDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SoftwareIntegrationApiSessionDto | null>;
        }));
    }

    protected processSoftwareIntegrationApi_UpdateSessionUiSelectionData(response: HttpResponseBase): Observable<SoftwareIntegrationApiSessionDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SoftwareIntegrationApiSessionDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    softwareIntegrationApi_UpdateSessionUiData(sessionId: string, dto?: SoftwareIntegrationApiUiDataDto | null | undefined): Observable<SoftwareIntegrationApiSessionDto | null> {
        let url_ = this.baseUrl + "/api/v3/SoftwareIntegrationApi/updateSessionUiData/sessionId/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSoftwareIntegrationApi_UpdateSessionUiData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSoftwareIntegrationApi_UpdateSessionUiData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SoftwareIntegrationApiSessionDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SoftwareIntegrationApiSessionDto | null>;
        }));
    }

    protected processSoftwareIntegrationApi_UpdateSessionUiData(response: HttpResponseBase): Observable<SoftwareIntegrationApiSessionDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SoftwareIntegrationApiSessionDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface AccountAuthorizationDisplayInfoDto {
    activeRoles?: Role[] | undefined;
    language?: AccountLanguage;
    activeCatalogSpecificRoles?: (EntityRoleAssignmentDisplayInfoDto | undefined)[] | undefined;
    activeCompanySpecificRoles?: (EntityRoleAssignmentDisplayInfoDto | undefined)[] | undefined;
}

export enum Role {
    None = "None",
    Admin = "Admin",
    Visitor = "Visitor",
    LicenseAdministrator = "LicenseAdministrator",
    LicenseViewer = "LicenseViewer",
    CatalogAdministrator = "CatalogAdministrator",
    CatalogViewer = "CatalogViewer",
    AccountManagerAdministrator = "AccountManagerAdministrator",
    AccountManagerViewer = "AccountManagerViewer",
}

export enum AccountLanguage {
    German = 0,
    English = 1,
}

export interface EntityRoleAssignmentDisplayInfoDto {
    entityId?: number;
    title?: string | undefined;
    roles?: Role[] | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };
}

export interface RolesDto {
    roles?: Role[] | undefined;
    rolesByCatalogId?: { [key: number]: Role[]; } | undefined;
    rolesByCompanyId?: { [key: number]: Role[]; } | undefined;
}

export interface SoftwarepartnerApiSessionDto {
    apiSessionId?: string;
    sessionId?: string;
    userId?: string;
    apiUserAgent?: string | undefined;
    softwareId?: string;
    lastActive?: Date;
    postMessageTargetOrigin?: string | undefined;
    communicationMode?: CommunicationMode;
    language?: Language;
}

export enum CommunicationMode {
    Direct = 0,
    PostMessageIFrame = 1,
    PostMessageWebView = 2,
    UrlNavigation = 3,
}

export enum Language {
    De = 0,
    En = 1,
}

export interface UserMenuDisplayInfoDto {
    isAdmin?: boolean;
    companyAdministrations?: (AdministrationDisplayInfoDto | undefined)[] | undefined;
    catalogAdministrations?: (AdministrationDisplayInfoDto | undefined)[] | undefined;
}

export interface AdministrationDisplayInfoDto {
    companyOrCatalogId?: number;
    catalogKey?: string | undefined;
    title?: string | undefined;
}

export interface SoftwareIntegrationApiSessionDto {
    sessionId?: string;
    applicationId?: number;
    applicationKey?: string;
    apiBaseUrl?: string | undefined;
    uiData?: SoftwareIntegrationApiUiDataDto | undefined;
    uiSelectionData?: SoftwareIntegrationApiUiSelectionDataDto | undefined;
    registeredCallbacks?: SoftwareIntegrationApiCallbackType[] | undefined;
    callbackMode?: SoftwareIntegrationApiCallbackMode;
    callbackTargetOrigin?: string | undefined;
    initialCatalogKey?: string | undefined;
    hostAppUserAgent?: string | undefined;
}

export interface SoftwareIntegrationApiUiDataDto {
    userId?: string;
    authenticatedUserId?: string | undefined;
    userAgent?: string | undefined;
    sessionId?: string;
}

export interface SoftwareIntegrationApiUiSelectionDataDto {
    currentElement?: CatalogElementDto | undefined;
    selectedElements?: (CatalogElementDto | undefined)[] | undefined;
}

export interface CatalogElementDto {
    catalogItemId?: number;
    catalogItemGuid?: string;
}

export enum SoftwareIntegrationApiCallbackType {
    None = "none",
    Export = "export",
    DragStart = "dragstart",
    LocationChanged = "locationchanged",
    CatalogItemLink = "catalogItemLink",
}

export enum SoftwareIntegrationApiCallbackMode {
    Default = "Default",
    PostMessage = "PostMessage",
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}